import { Component, ViewEncapsulation } from "@angular/core";

import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: 'checkbox-cell',
  templateUrl: './checkbox-renderer.component.html',
  styleUrls: ['./checkbox-renderer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CheckBoxRendererComponent implements ICellRendererAngularComp {
  isSelected: boolean;
  isCheckboxDisabled: boolean;
  params: any;

  constructor() {
  }

  initilize(params: ICellRendererParams) {
    if (params.data) {
      this.params = params;
      this.isSelected = params.getValue();
      const disabledParam = params['isCheckboxDisabled'] ?? params.colDef?.cellRendererParams?.['isCheckboxDisabled'];
      this.isCheckboxDisabled = disabledParam instanceof Function
        ? disabledParam(params)
        : (disabledParam ?? params.data.isCheckboxDisabled);
    }
  }

  onClick(event) {
    this.isSelected = event.target.checked;
    this.params.setValue(this.isSelected);

    const clickHandler = this.params.onClick ?? this.params.colDef?.cellRendererParams?.onClick;
    if (clickHandler instanceof Function && event && event.target) {
      clickHandler(event.target.checked, this.params);
    }

  }

  // called on init
  agInit(params: any): void {
    this.initilize(params);
  }

  // called when the cell is refreshed
  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

}




